import { IOrderReplacementEntity } from '../Services/api/orders-replacement/orders-replacement.interface';

export interface IReplacementProductsSummary {
  label: string;
  detail: string;
  tooltip: string;
}

function getReplacementProductName(
  item: IOrderReplacementEntity['products'][number],
): string {
  return (
    item.product?.internalName ||
    item.product?.name ||
    'Produto'
  );
}

function getReplacementProductQuantity(
  item: IOrderReplacementEntity['products'][number],
): number {
  const raw = item as IOrderReplacementEntity['products'][number] & {
    total_quantity?: number | string;
    order_quantity?: number | string;
  };

  const total = item.totalQuantity ?? raw.total_quantity;
  if (total != null && !Number.isNaN(Number(total))) {
    return Number(total);
  }

  const order = item.orderQuantity ?? raw.order_quantity;
  if (order != null && !Number.isNaN(Number(order))) {
    return Number(order);
  }

  return Number(item.quantity) || 0;
}

export function buildReplacementProductsSummary(
  products?: IOrderReplacementEntity['products'],
): IReplacementProductsSummary {
  if (!products?.length) {
    return {
      label: 'Sem produtos',
      detail: '',
      tooltip: 'Nenhum produto neste pedido',
    };
  }

  const items = products.map((item) => ({
    name: getReplacementProductName(item),
    qty: getReplacementProductQuantity(item),
  }));

  const totalQty = items.reduce((acc, item) => acc + item.qty, 0);
  const tooltip = items.map((item) => `${item.name} — ${item.qty} un.`).join('\n');
  const preview = items
    .slice(0, 2)
    .map((item) => `${item.name} (${item.qty})`)
    .join(' · ');
  const remaining = items.length - 2;

  return {
    label: `${items.length} produto${items.length === 1 ? '' : 's'} · ${totalQty} un.`,
    detail: remaining > 0 ? `${preview} · +${remaining}` : preview,
    tooltip,
  };
}
